<template>
  <div>
    <v-btn
      :href="getInvoiceUrl(item.id)"
      target="_blank"
      color="primary"
      outlined
      class="mb-4"
    >
      Show Invoice
      <v-icon
        right
      >
        mdi-open-in-new
      </v-icon>
    </v-btn>

    <v-text-field
      name="serialNumber"
      label="Serial Number"
      readonly
      v-model="item.serialNumber"
      :rules="stringValidation"
    />

    <v-text-field
      name="amount"
      label="Amount"
      readonly
      v-model="item.amount"
      :rules="stringValidation"
    />

    <v-text-field
      name="companyName"
      label="Company"
      v-model="item.companyName"
      :rules="stringValidation"
    />

    <v-textarea
      auto-grow
      rows="1"
      name="companyInfo"
      label="Company Address"
      v-model="item.companyInfo"
      :rules="stringValidation"
    />

    <v-select
      name="status"
      label="Status"
      v-model="item.status"
      :items="statusList"
    />

    <div v-if="item.extRefs">
      <div class="caption">
        External References
      </div>
      <div class="rounded body-1 pa-2 text--disabled" style="border: 1px solid currentcolor">
        <div v-for="ref in item.extRefs" :key="ref" class="text--primary">
          {{ref}}
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {apiUrl} from '@dynapp/wc-api-generic'

export default {
  props: {
    item: {
      type: Object
    }
  },
  data () {
    return {
      stringValidation: [v => (v != null && v !== '') || 'Cannot be empty'],
      statusList: [{
        text: 'CREATED',
        value: 'CREATED',
        disabled: false
      }, {
        text: 'SENT',
        value: 'SENT',
        disabled: false
      }, {
        text: 'PAID',
        value: 'PAID',
        disabled: false
      }]
    }
  },
  computed: {
  },
  methods: {
    getInvoiceUrl (invoiceId) {
      //console.log('show '+apiUrl({dataObject: 'dync-appshop-invoice'}, '/'+this));
      return apiUrl({dataObject: 'dync-appshop-invoice'}, invoiceId);
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
